export default __webpack_public_path__ + "aaa5f3afc8d50932afb9866610f28e17.png";